import React from 'react';
import { Check, Crown } from 'lucide-react';
export function Upsell() {
  const features = ['Cómo subir la cuota sin perder alumnos — con guiones exactos', 'Cómo llenar turnos sin gastar en publicidad', 'Instagram como máquina de captación de alumnos', 'Sistema de cobros con mora cero', 'Plan de 90 días semana a semana', '10 guiones de WhatsApp para cerrar ventas', 'Protocolo anti clase gratis', 'Cómo recuperar ex-alumnos en 7 días', 'Embudo de captación por historias', 'Calculadora de rentabilidad por turno', 'Anuncios de aumento sin perder facturación'];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-482">
      <div className="max-w-5xl mx-auto" data-id="element-483">
        <div className="text-center mb-10 md:mb-14" data-id="element-484">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-485">
            <Crown className="w-4 h-4" data-id="element-486" /> Upgrade premium
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-487">
            🔥 ¿Qué agrega{' '}
            <span className="text-primary" data-id="element-488">"Turnos Llenos"?</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-489">
            Porque tener las mejores clases no alcanza si{' '}
            <span className="text-white font-bold" data-id="element-490">
              los turnos están a la mitad.
            </span>
          </p>
        </div>

        <div className="bg-surface border border-primary/30 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(249,168,212,0.08)] mb-8" data-id="element-491">
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-492">
            {features.map((f, i) => <div key={i} className="flex items-start gap-3 bg-black/30 border border-zinc-800/60 rounded-xl p-3 md:p-4" data-id="element-493">
                <div className="bg-primary/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-494">
                  <Check className="w-3.5 h-3.5 text-primary" data-id="element-495" />
                </div>
                <span className="text-zinc-200 text-sm md:text-base leading-tight" data-id="element-496">
                  {f}
                </span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-zinc-200 leading-relaxed max-w-2xl mx-auto" data-id="element-497">
          Si además de dar mejores clases querés{' '}
          <span className="text-primary font-bold" data-id="element-498">llenar tus turnos,</span>{' '}
          esta es tu opción.
        </p>
      </div>
    </section>;
}